export default "__VITE_ASSET__ef7133f1__"